 import { Button } from "@blueprintjs/core";
//  const FigureFitToPage = ({ element }) => {
//   const page = element.page;

//   if (!page) return null;
//   return (
//     <Button
//       minimal
//       onClick={() => {
//         element.set({
//           rotation: 0,
//           x: 0,
//           y: 0,
//           width: page.computedWidth,
//           height: page.computedHeight,
//         });
//       }}
//     >
//       Fit to page
//     </Button>
//   );
// };

// export default FigureFitToPage;

const FigureFitToPage = ({ store, element }) => {
  return (
    <Button
      className="bp5-button bp5-minimal"
      onClick={() => {
        const page = store.activePage;

        if(element.type === 'figure'){
          element.set({
            rotation: 0,
            x: 0,
            y: 0,
            width: page.computedWidth,
            height: page.computedHeight,
          })
          return;
        }

        if (element.type !== "image" ) return;

        if (element.stretchEnabled) {
          // 💡 Custom logic for stretching to full canvas
          element.set({
            x: 0,
            y: 0,
            width: page.width,
            height: page.height,
          });
        } else {
          // 🔁 Default proportional "fit to page"
          const scale = Math.min(
            page.width / element.originalWidth,
            page.height / element.originalHeight
          );

          const newWidth = element.originalWidth * scale;
          const newHeight = element.originalHeight * scale;

          element.set({
            width: newWidth,
            height: newHeight,
            x: (page.width - newWidth) / 2,
            y: (page.height - newHeight) / 2,
          });
        }
      }}
    >
      Fit to Page
    </Button>
  );
};
export default FigureFitToPage;
